import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import Fade from "react-reveal/Fade";
import { useAuth } from "../../../../context/AuthContext";
import { useForm } from "react-hook-form";
import CheckIcon from "@mui/icons-material/Check";
import Alert from "@mui/material/Alert";
import { useStateContext } from "../../../../context/StateContext_KO";
import {
  functions,
  httpsCallable,
  addDoc,
  collection,
  db,
  getDocs,
} from "../../../../firebase";
import FormControl from "@mui/material/FormControl";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";

const EnterAddress = (props) => {
  const { t, i18n } = useTranslation();
  const [error, setError] = useState("");
  const { getAddresses, currentUser } = useAuth();
  const [addressIndex, setAddressIndex] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [list, setList] = useState([]);
  const [presetshippingAddress, setpresetshippingAddress] = useState(null);
  const [allAddressesFromDB, setAllAddressesFromDB] = useState(
    getAddresses() || null
  );
  const { basket } = useStateContext();

  const [checked, setChecked] = React.useState(true);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  console.log(checked);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    console.log(props.shippingAddress);
    if (props.shippingAddress) {
      setpresetshippingAddress(props.shippingAddress);
      setValue("firstname", props.shippingAddress.firstname, {
        shouldValidate: true,
      });
      setValue("lastname", props.shippingAddress.lastname, {
        shouldValidate: true,
      });
      setValue("address", props.shippingAddress.address, {
        shouldValidate: true,
      });
      setValue("apt", props.shippingAddress.apt, {
        shouldValidate: true,
      });
      setValue("city", props.shippingAddress.city, {
        shouldValidate: true,
      });
      setValue("state", props.shippingAddress.state, {
        shouldValidate: true,
      });
      setValue("zipcode", props.shippingAddress.zipcode, {
        shouldValidate: true,
      });
    } else if (getAddresses().length > 0) {
      setValue("firstname", getAddresses()[addressIndex || 0].firstname, {
        shouldValidate: true,
      });
      setValue("lastname", getAddresses()[addressIndex || 0].lastname, {
        shouldValidate: true,
      });
      setValue("address", getAddresses()[addressIndex || 0].address, {
        shouldValidate: true,
      });
      setValue("apt", getAddresses()[addressIndex || 0].apt.replace("#", ""), {
        shouldValidate: true,
      });
      setValue("city", getAddresses()[addressIndex || 0].city, {
        shouldValidate: true,
      });
      setValue("state", getAddresses()[addressIndex || 0].state, {
        shouldValidate: true,
      });
      setValue("zipcode", getAddresses()[addressIndex || 0].zipcode, {
        shouldValidate: true,
      });
    }
  }, []);

  const changeAddressIndex = (index) => {
    setAddressIndex(index);
    if (getAddresses().length > 0) {
      setValue("firstname", getAddresses()[index || 0].firstname, {
        shouldValidate: true,
      });
      setValue("lastname", getAddresses()[index || 0].lastname, {
        shouldValidate: true,
      });
      setValue("address", getAddresses()[index || 0].address, {
        shouldValidate: true,
      });
      setValue("apt", getAddresses()[index || 0].apt, {
        shouldValidate: true,
      });
      setValue("city", getAddresses()[index || 0].city, {
        shouldValidate: true,
      });
      setValue("state", getAddresses()[index || 0].state, {
        shouldValidate: true,
      });
      setValue("zipcode", getAddresses()[index || 0].zipcode, {
        shouldValidate: true,
      });
    }
  };

  const submit = async (data) => {
    setProcessing(true);

    const easyPostcreateAddress = httpsCallable(
      functions,
      "easyPostcreateAddress"
    );

    try {
      await easyPostcreateAddress({
        address: data.address,
        city: data.city,
        state: data.state,
        zipcode: data.zipcode,
        company: data.firstname + " " + data.lastname,
        phone: "",
      })
        .then(async (result) => {
          console.log(result);
          if (result.data.verifications.delivery.success) {
            // save the address to the checkout page
            props.setShippingAddress({
              firstname: data.firstname,
              lastname: data.lastname,
              address: data.address,
              apt: data.apt,
              city: data.city,
              state: data.state,
              zipcode: data.zipcode,
            });

            if (checked) {
              try {
                const querySnapshot = await getDocs(
                  collection(db, "users", currentUser.uid, "address")
                );
                let found = false;

                querySnapshot.forEach((doc) => {
                  console.log(doc.data());
                  if (doc.data()) {
                    if (
                      doc.data().firstname.trim().toUpperCase() ===
                        data.firstname.trim().toUpperCase() &&
                      doc.data().lastname.trim().toUpperCase() ===
                        data.lastname.trim().toUpperCase() &&
                      doc.data().address.trim().toUpperCase() ===
                        data.address.trim().toUpperCase() &&
                      doc.data().apt.trim().toUpperCase() ===
                        data.apt.trim().toUpperCase() &&
                      doc.data().city.trim().toUpperCase() ===
                        data.city.trim().toUpperCase() &&
                      doc.data().state.trim().toUpperCase() ===
                        data.state.trim().toUpperCase() &&
                      doc.data().zipcode.trim().toUpperCase() ===
                        data.zipcode.trim().toUpperCase()
                    ) {
                      found = true;
                    }
                  }
                  console.log(doc.id, " => ", doc.data());
                });
                console.log("======> found", found);
                if (!found) {
                  const docRef2 = await addDoc(
                    collection(db, "users", currentUser.uid, "address"),
                    {
                      firstname: data.firstname,
                      lastname: data.lastname,
                      address: data.address,
                      apt: data.apt,
                      city: data.city,
                      state: data.state,
                      zipcode: data.zipcode,
                    }
                  );
                  console.log(docRef2);
                }
              } catch (error) {
                console.log(error);
              }
            }

            props.goToNextStep();
          }
        })
        .catch((err) => {
          setProcessing(false);
          setError("It is an invalid address. Please check again.");
        });
    } catch (err) {
      setProcessing(false);
      setError("It is an invalid address. Please check again.");
    }
  };

  return (
    <Box sx={{ pt: 7, px: 7, pb: 10 }}>
      <Fade delay={300}>
        <Box
          sx={{
            display: "flex",
            width: 1,
            borderBottom: "1px solid lightgray",
            paddingBottom: "10px",
          }}
        >
          <Box sx={{ pr: 4 }}>{t("email")}</Box>
          <Box>{props.email}</Box>
          <Box
            sx={{
              fontSize: "14px",
              color: "gray",
              marginLeft: "auto",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => props.goToFirstStep()}
          >
            {t("edit")}
          </Box>
        </Box>

        <Box sx={{ pt: 6 }}>
          <Box sx={{ pb: 2 }}>{t("Your Shipping Address")}</Box>
          <Box>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    defaultChecked
                  />
                }
                label={t("Save this address on my profile")}
              />
            </FormGroup>
          </Box>

          <Box>{error && <Alert severity="error">{error}</Alert>}</Box>

          <Box sx={{ pb: 1 }}>
            {errors.firstname && (
              <Alert severity="warning" sx={{ my: 2 }}>
                {errors.firstname?.message}
              </Alert>
            )}
            {!errors.firstname && errors.lastname && (
              <Alert severity="warning">{errors.lastname?.message}</Alert>
            )}
            {!errors.firstname && !errors.lastname && errors.address && (
              <Alert severity="warning">{errors.address?.message}</Alert>
            )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              errors.city && (
                <Alert severity="warning">{errors.city?.message}</Alert>
              )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              !errors.city &&
              errors.state && (
                <Alert severity="warning">{errors.state?.message}</Alert>
              )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              !errors.city &&
              !errors.state &&
              errors.zipcode && (
                <Alert severity="warning">{errors.zipcode?.message}</Alert>
              )}
          </Box>
          {!processing ? (
            <form
              onSubmit={handleSubmit((data) => {
                submit(data);
              })}
            >
              <TextField
                autoComplete="given-name"
                variant="filled"
                fullWidth
                label={t("fn") + "*"}
                autoFocus
                sx={{ width: 1, mb: 2 }}
                {...register("firstname", {
                  required: "First name is required.",
                  minLength: {
                    value: 1,
                    message: "First Name's minimum length is 1.",
                  },
                })}
              />
              <TextField
                fullWidth
                variant="filled"
                label={t("ln") + "*"}
                autoComplete="family-name"
                {...register("lastname", {
                  required: "Last name is required.",
                  minLength: {
                    value: 1,
                    message: "Last Name's minimum length is 1.",
                  },
                })}
              />
              <TextField
                id="outlined-basic"
                label={t("ck_address") + "*"}
                variant="filled"
                sx={{ width: 1, mt: 2 }}
                {...register("address", {
                  required: "Address is required.",
                })}
              />
              <TextField
                id="outlined-basic"
                label={t("Apt")}
                variant="filled"
                sx={{ width: 1, mt: 2 }}
                {...register("apt")}
              />
              <TextField
                id="outlined-basic"
                label="City"
                variant="filled"
                sx={{ width: 1, mt: 2 }}
                {...register("city", {
                  required: "City is required.",
                })}
              />
              <FormControl variant="filled" sx={{ mt: 2, width: "100%" }}>
                <select
                  style={{
                    width: "100%",

                    mt: 2,
                    border: "none",
                    height: "50px",
                    backgroundColor: "#f0f0f0",
                    borderBottom: "1px solid #616161",
                    paddingLeft: "8px",
                  }}
                  {...register("state", {
                    required: "This is required.",
                  })}
                >
                  <option value="" disabled selected>
                    Select your option
                  </option>

                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>

                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>

                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
              </FormControl>
              {/* <TextField
							id="outlined-basic"
							label="State"
							variant="filled"
							sx={{ width: 1, mt: 2 }}
							{...register("state", {
								required: "This is required.",
							})}
						/> */}
              <TextField
                id="outlined-basic"
                label="Zipcode"
                variant="filled"
                sx={{ width: 1, mt: 2 }}
                {...register("zipcode", {
                  required: "Zipcode is required.",
                })}
              />

              <button
                type="submit"
                disabled={processing}
                className="custom_btn"
                style={{ marginTop: "20px" }}
                role="link"
                // onClick={() => props.goToNextStep()}
              >
                {processing ? "...Processing" : "Go To Payment"}
              </button>
            </form>
          ) : (
            <Box
              sx={{
                width: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                color: "#f3756d",
              }}
            >
              <CircularProgress />
              &nbsp;&nbsp;
              <Box className="">Validating your address</Box>
            </Box>
          )}
        </Box>
      </Fade>

      <Box sx={{ pt: 5 }}>Change the shipping address to</Box>
      {allAddressesFromDB.map((anObjectMapped, index) => {
        return (
          <Box
            key={`${anObjectMapped.address}`}
            onClick={() => changeAddressIndex(index)}
            sx={{
              p: 3,
              border: "1px solid black",
              mt: 3,
              cursor: "pointer",
              "&:hover": { background: "#eceff1" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "10px",
                  backgroundColor: "#bc5b4b",
                  mr: 2,
                  position: "relative",
                  top: "-2px",
                }}
              ></Box>
              {anObjectMapped.firstname} - {anObjectMapped.lastname}
            </Box>
            <Box>
              {anObjectMapped.address} {anObjectMapped.apt}{" "}
              {anObjectMapped.city} {anObjectMapped.state}{" "}
              {anObjectMapped.zipcode}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default EnterAddress;
